const Dashboard = () =>{
    return(
       <>
          {/* <div class="row">
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-primary card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="fas fa-users"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Total Employees</p>
                           <h4 class="card-title">1,294</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-info card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="fas fa-user-check"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Leaves Applied</p>
                           <h4 class="card-title">1303</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-success card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="fas fa-chart-pie"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Leaves Approved</p>
                           <h4 class="card-title">$ 1,345</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-secondary card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="far fa-check-circle"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Leaves Notapproved</p>
                           <h4 class="card-title">576</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div> */}
           
             <div class="row">
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="icon-pie-chart text-warning"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Total Employees</p>
                           <h4 class="card-title">150</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="icon-wallet text-success"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Leaves Applied</p>
                           <h4 class="card-title">12</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="icon-close text-danger"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Leaves Approved</p>
                           <h4 class="card-title">2</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row">
                       <div class="col-5">
                         <div class="icon-big text-center">
                           <i class="icon-social-twitter text-primary"></i>
                         </div>
                       </div>
                       <div class="col-7 col-stats">
                         <div class="numbers">
                           <p class="card-category">Leaves Notapproved</p>
                           <h4 class="card-title">3</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             
             {/* <div class="row">
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row align-items-center">
                       <div class="col-icon">
                         <div
                           class="icon-big text-center icon-primary bubble-shadow-small"
                         >
                           <i class="fas fa-users"></i>
                         </div>
                       </div>
                       <div class="col col-stats ms-3 ms-sm-0">
                         <div class="numbers">
                           <p class="card-category">Visitors</p>
                           <h4 class="card-title">1,294</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row align-items-center">
                       <div class="col-icon">
                         <div
                           class="icon-big text-center icon-info bubble-shadow-small"
                         >
                           <i class="fas fa-user-check"></i>
                         </div>
                       </div>
                       <div class="col col-stats ms-3 ms-sm-0">
                         <div class="numbers">
                           <p class="card-category">Subscribers</p>
                           <h4 class="card-title">1303</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row align-items-center">
                       <div class="col-icon">
                         <div
                           class="icon-big text-center icon-success bubble-shadow-small"
                         >
                           <i class="fas fa-luggage-cart"></i>
                         </div>
                       </div>
                       <div class="col col-stats ms-3 ms-sm-0">
                         <div class="numbers">
                           <p class="card-category">Sales</p>
                           <h4 class="card-title">$ 1,345</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="col-sm-6 col-md-3">
                 <div class="card card-stats card-round">
                   <div class="card-body">
                     <div class="row align-items-center">
                       <div class="col-icon">
                         <div
                           class="icon-big text-center icon-secondary bubble-shadow-small"
                         >
                           <i class="far fa-check-circle"></i>
                         </div>
                       </div>
                       <div class="col col-stats ms-3 ms-sm-0">
                         <div class="numbers">
                           <p class="card-category">Order</p>
                           <h4 class="card-title">576</h4>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div> */}
       </>
    );   
 }
 export default Dashboard;